import { IOPExpSessionData, TDateSelectValues } from '../../models/common';
import { IPHRequest } from '../../models/purchase-history';
import { DateRanges } from '../DateRanges';
import { PHODPageData } from '../general';
import { formatDate } from './common';

interface initPHRequestBuilderProps {
  customerType: string;
  customerRole: string;
  searchParams: URLSearchParams;
  dateSelectorValue: keyof typeof DateRanges;
  svocID: string;
  initResultsFilter: 'allOrders' | 'myOrders';
  sessionData?: {
    selectedDate: TDateSelectValues;
    userView: 'allOrders' | 'myOrders';
    startDate: string;
    endDate: string;
    customDateUsed: boolean;
    showCalendar: boolean;
  };
  timezone: string;
}

export const initLDRequestBuilder = ({
  dateSelectorValue,
  searchParams,
  svocID,
  searchType,
  resultsFilter,
  sortBy,
  sortOrder,
  groupBy,
}: {
  dateSelectorValue: TDateSelectValues;
  searchParams: URLSearchParams;
  svocID: string;
  searchType: string;
  resultsFilter: string;
  sortBy: string;
  sortOrder: string;
  groupBy: string;
}) => {
  return {
    pageSize: 20,
    pageNumber: 1,
    startDate:
      searchParams.get('startDate') ||
      DateRanges[dateSelectorValue as keyof typeof DateRanges].startDate,
    endDate:
      searchParams.get('endDate') ||
      DateRanges[dateSelectorValue as keyof typeof DateRanges].endDate,
    customerAccountId: svocID || '',
    sortBy,
    sortOrder,
    searchType,
    resultsFilter,
    groupBy,
  };
};

export const initPHRequestBuilder = ({
  customerType,
  customerRole,
  searchParams,
  dateSelectorValue,
  svocID,
  initResultsFilter,
  sessionData,
  timezone,
}: initPHRequestBuilderProps): IPHRequest => {
  const OPExpSessionData = PHODPageData();

  const createInitSearchBy = () => {
    if (
      searchParams.get('requestSearchSelectorValue') &&
      searchParams.get('requestSearchCriteria')
    ) {
      const criteria = searchParams.get('requestSearchSelectorValue') || '';
      const value = searchParams.get('requestSearchCriteria') || '';
      const initSearchBy = { [criteria]: value };
      return [initSearchBy];
    }
    return undefined;
  };

  if (customerType === 'b2b' || customerRole !== '') {
    const rawStartDate =
      sessionData?.startDate ||
      searchParams.get('startDate') ||
      DateRanges[dateSelectorValue].startDate;
    const rawEndDate =
      sessionData?.endDate ||
      searchParams.get('endDate') ||
      DateRanges[dateSelectorValue].endDate;

    return {
      pageSize: 20,
      pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
      startDate: formatDate(rawStartDate),
      endDate: formatDate(rawEndDate),
      customerAccountId: svocID || '',
      sortBy: 'salesDate',
      sortOrder: 'desc',
      searchType: 'ORDERS',
      resultsFilter: initResultsFilter,
      searchBy: createInitSearchBy(),
      timezone,
      searchValue: '',
    };
  }
  return {
    pageSize: 20,
    pageNumber: (OPExpSessionData as IOPExpSessionData)?.lastPage ?? 1,
    startDate: formatDate(DateRanges[dateSelectorValue].startDate),
    endDate: formatDate(DateRanges[dateSelectorValue].endDate),
    timezone,
  };
};
